import { compose } from '@reduxjs/toolkit';
import { createShortcutReducer } from './createShortcut';
import { deleteShortcutReducer } from './deleteShortcut';
import { fetchShortcutPriceGroupsReducer } from './fetchShortcutPriceGroups';
import { fetchShortcutsReducer } from './fetchShortcuts';
import { updateShortcutReducer } from './updateShortcut';

export const extraReducers = compose(
  fetchShortcutsReducer,
  fetchShortcutPriceGroupsReducer,
  deleteShortcutReducer,
  createShortcutReducer,
  updateShortcutReducer,
);

export { createShortcut } from './createShortcut';
export { deleteShortcut } from './deleteShortcut';
export { fetchShortcutPriceGroups } from './fetchShortcutPriceGroups';
export { fetchShortcuts } from './fetchShortcuts';
export { updateShortcut } from './updateShortcut';
